<template>
  <div style="height:570px; overflow-y:auto;">
    <b-spinner
      v-if="isLoading"
      type="grow"
      class="text-center"
      style="margin-top: 10%; position:absolute;"
      variant="primary"
    ></b-spinner>
    <b-navbar toggleable="lg" type="dark" variant="light">
      <b-navbar-brand href="#" class="text-dark">
        <strong>Manage Users</strong>
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-nav-form>
          <b-form-group
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
          >
            <b-input-group size="sm">
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-nav-form>
      </b-navbar-nav>
    </b-navbar>

    <b-table
      class="mx-1"
      sticky-header="calc(100vh - 200px)"
      ref="table"
      bordered
      id="users-data-table"
      :busy.sync="isLoading"
      :items="myProvider"
      :fields="fields"
      :filter="filter"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      responsive="sm"
    >
      <template v-slot:cell(edit_actions)="data">
        <b-button type="button" variant="info">
          <font-awesome-icon
            v-b-tooltip.hover
            title="Edit User"
            class="mr-1 text-light"
            icon="edit"
          />Edit
        </b-button>
      </template>
      <template v-slot:cell(ban_actions)="data">
        <b-button type="button" class="mr-1" variant="info">OTP</b-button>
        <b-button type="button" variant="danger">
          <font-awesome-icon
            v-b-tooltip.hover
            title="Ban User"
            class="mr-1 text-light"
            icon="trash"
          />Ban
        </b-button>
      </template>
    </b-table>
    <b-row>
      <b-col cols="2">
        <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
      </b-col>
      <b-col>
        <b-pagination
          class="float-right"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
          aria-controls="my-table"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import { Helper } from "../../helpers";
// import AppHeader from "../../components/header/header";
import { HTTP } from "../../utils/HTTP";
export default {
  name: "ClientProfileManageUsers",
  components: {},
  data() {
    return {
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      sortBy: "members_display_name",
      sortDesc: false,
      pageOptions: [5, 10, 25, 50, 75, 100],
      items: [],
      isLoading: false,
      filter: null,
      fields: [
        {
          key: "members_display_name",
          label: "Fullname",
          sortable: true
        },
        {
          key: "email",
          label: "Email",
          sortable: true
        },
        {
          key: "company",
          label: "Company Name",
          sortable: true
        },
        {
          key: "g_title",
          label: "User Type",
          sortable: false
        },
        {
          key: "edit_actions",
          label: "Edit Actions",
          sortable: false
        },
        {
          key: "ban_actions",
          label: "Ban Actions",
          sortable: false
        }
      ]
    };
  },

  computed: {
    rows() {
      return this.totalRows;
    }
  },
  mounted() {
    //   this.usesListProvider();
  },
  methods: {
    async myProvider() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/getuserslist", formData, {
        Authorization: token
      });
      return result
        .then(response => {
          //   // console.log(response.data);
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [error];
        });
    }
  }
};
</script>

<style scoped>
</style>
